import { Trans } from '@lingui/macro';
import React, { FC, useState, useEffect, useContext } from 'react'
import { isEmpty } from 'underscore';
import { Context } from '../../..';
import DocumentsService from '../../../services/DocumentsService';

interface ItemProps {
    item: {
        id: number,
        point: string;
    },
    setPopov: (value: boolean) => void,
    setTitle: (value: string) => void,
    docData: object,
    setDocData: (value: any) => void
};

const Item = (props: ItemProps) => {
    const { item, setPopov, setTitle, docData, setDocData } = props;
    const { id, point } = item;

    const onClick = () => {
        setDocData({ ...docData, 'point': id });
        setPopov(false);
        setTitle(point);
    };

    return (
        <div className="form-check" onClick={() => onClick()} >
            &#8226;&nbsp;<label className="form-check-label" htmlFor={`item${id}`}>{point}</label>
        </div>
    );
};

interface Props {
    docData: any,
    setDocData: (value: object) => void,
    cleanData: boolean,
    setCleanData: (value: boolean) => void,
};

export const DocumentPointModal: FC<Props> = ({ docData, setDocData, cleanData, setCleanData }) => {
    const { store } = useContext(Context);
    const [points, setPoints] = useState<[]>([]);
    const [popov, setPopov] = useState<boolean>(false);
    const [title, setTitle] = useState<string>(docData.point && docData.point.length ? docData.point.point : '');

    const getPoints = async () => {
        const res = await DocumentsService.getPoints();
        setPoints(res.data.results);
    };

    useEffect(() => {
        getPoints();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (cleanData) {
            setTitle('');
            setCleanData(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cleanData]);


    const getItems = () => {
        if (!isEmpty(points)) {
            return points.map(item => <Item key={item['id']} {...{ item, setPopov, setTitle, docData, setDocData }} />);
        } else {
            return <span><Trans>Nothing found</Trans></span>
        }
    };

    const openPopov = (e: React.ChangeEvent<any>) => {
        setPopov(true);
        e.target.value = ''
    };

    const closePopov = () => {
        setPopov(false);
    };

    return (
        <div className="form-group" style={{ position: "relative" }}>
            <div className="input-group">
                <div className="input-group-control w-100">

                    <input type="text" className="form-control"
                        placeholder={store.lang === 'ba' ? 'Рангты һайлағыҙ' : store.lang === 'ru' ? 'Выберите категорию' : 'Choose a grade'}
                        value={title}
                        title={title}
                        readOnly
                        autoComplete="off"
                        onClick={(e: React.ChangeEvent<any>) => openPopov(e)}
                        onChange={() => { }} />
                </div>
            </div>
            {popov ?
                <div className="form-group popov">
                    <div className="popov__title d-flex justify-content-end">
                        <div>
                            <input type='button' className='btn text-primary' value={store.lang === 'ba' ? 'Ябырға' : store.lang === 'ru' ? 'Закрыть' : 'Close'} onClick={() => { closePopov() }} />
                        </div>
                    </div>
                    <div className="form-group">
                        {getItems()}
                    </div>
                </div>
                : null}
        </div>
    );
};